import React, { useState } from 'react';
import NewStageForm from './NewStageForm';
import DashboardBuilderStages from './DashboardBuilderStages';
import { Button, InlineNotification } from 'carbon-components-react';
import { connect } from 'react-redux';
import { setTempConfigFile } from '../../../actions';
import funcTranslateHelper from '../../../i18next/funcTranslateHelper';

import { Add16 } from '@carbon/icons-react';
// eslint-disable-next-line no-unused-vars
import style from './style.css';

function Builder (props) {
  const { tempConfigFile, saveTempConfigFile } = props;
  const [open, setOpen] = useState(false);
  const [openNotication, setOpenNotication] = useState(false);
  const configFile = tempConfigFile || [];

  const disableBuilder = configFile.disableBuilder;

  // MODAL FUNCTIONS
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      {open ? (
        <NewStageForm
          setOpenNotication={setOpenNotication}
          setConfigFile={saveTempConfigFile}
          configFile={configFile}
          handleClose={handleClose}
          open={open}
        />
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: '20px'
          }}
        >
          {!disableBuilder &&
            <Button
              onClick={handleOpen}
              renderIcon={Add16}
              style={{ height: 'fit-content' }}
            >
              {funcTranslateHelper('Builder.builder.btn.Añadir estado')}
            </Button>}
          {openNotication && (
            <InlineNotification
              iconDescription='Cerrar'
              kind='success'
              notificationType='inline'
              role='alert'
              style={{
                marginTop: '0px',
                marginBottom: '0px',
                minWidth: '30rem'
              }}
              lowContrast
              title={funcTranslateHelper('Builder:builder:success')}
            />
          )}
        </div>
      )}
      {configFile && (
        <DashboardBuilderStages
          configFile={configFile}
          setConfigFile={saveTempConfigFile}
          setOpenNotication={setOpenNotication}
        />
      )}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    tempConfigFile: state.tempConfigFile
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveTempConfigFile: data => dispatch(setTempConfigFile(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Builder);
